// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { createRefetchContainer, graphql } from 'react-relay';
// material-ui
import { DataGrid } from '../ui/data-grid/data-grid';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import IconRefresh from 'material-ui/svg-icons/av/replay';
// Отображение скрытых
import ShowHiddenElement from '../showHiddenElement/index';
// Pagination
import Pagination from '../controls/pagination/pagination';
import MainListItem from './MainListItem';

import '../ui/column.css';
import '../ui/paper.css';
import '../ui/title.css';
import './main.css';
import { styles } from '../../lib/styles';

type ArticleItem = {
	id: string,
	title: string,
	section: string,
	sectionName: string,
	availableAt: Date,
	state: string,
	authorName: ?string,
};

type Props = {
	history: Object,
	location: Object,
	relay: Object,
	viewer: {
		articles: {
			totalCount: number,
			articles: Array<ArticleItem>,
		},
	},
};

type State = {
	pageCursor: number,
	currentQuery: ?string,
	states: Array<?string>,
	totalPages: number,
	searchText: ?string,
};

class Main extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		const pageNumber = this.props.location.hash ? parseInt(this.props.location.hash.replace('#', ''), 10) : 1;
		this.state = {
			states: [],
			pageCursor: pageNumber,
			currentQuery: '',
			searchText: '',
			totalPages: Math.ceil(this.props.viewer.articles.totalCount / 12),
		};
	}

	componentWillReceiveProps(nextProps: Object) {
		this.setState({ totalPages: Math.ceil(nextProps.viewer.articles.totalCount / 12) });
	}

	changeHiddenShow = (flag: boolean) => {
		const stringStatus = flag ? ['deleted'] : ['available', 'draft'];
		const vars = () => ({
			page: 1,
			states: stringStatus,
			search: this.state.currentQuery ? this.state.currentQuery : null,
		});

		this.props.relay.refetch(vars, null, () => {
			this.setState({
				pageCursor: 1,
				states: stringStatus,
				currentQuery: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
				searchText: '',
			});
		});
	};

	refreshPage = (): void => {
		window.location = window.location;
	};

	changePageUrl = (path: number) => {
		if (window.history.pushState) {
			window.history.pushState(null, null, `/?page#${path}`);
		} else {
			this.props.history.replace(`/?page#${path}`);
		}
	};

	changePage = (pageNumber: number) => {
		const refetchVars = () => ({
			page: pageNumber,
			states: this.state.states,
			search: this.state.searchText,
		});

		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({ pageCursor: pageNumber });
		});
		this.changePageUrl(pageNumber);
	};

	searchFieldKeyPressed = (e: Object) => {
		if (e.charCode !== 13) {
			return;
		}
		console.log('===');

		const refetchVars = () => ({
			page: 1,
			states: this.state.states,
			search: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
		});

		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({
				pageCursor: 1,
				currentQuery: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
			});
			console.log(this.state);
		});
	};

	render() {
		const items = this.props.viewer.articles.articles;

		const columns = [
			{ title: 'Дата', width: '15%' },
			{ title: 'Заголовок', width: '30%' },
			{ title: 'Автор', width: '20%' },
			{ title: 'Тип материала', width: '20%' },
			{ title: 'Статус', width: '15%' }
		];

		return (
			<section className="wrapper">
				<div className="paper-wrapper">
					<section className="paper paper_main articles">
						<header className="paper-header articles-header">
							<h3 className="articles-header--title">Материалы</h3>
							<div className="articles-controls--search">
								<TextField
									style={{
										maxWidth: 222,
										fontSize: 14,
										marginLeft: 41,
										height: 38,
									}}
									inputStyle={{
										fontSize: 14,
									}}
									underlineStyle={{
										marginTop: -2,
									}}
									textareaStyle={{
										marginBottom: 5,
									}}
									hintStyle={{
										bottom: 11,
									}}
									hintText="Поиск"
									value={this.state.searchText}
									onKeyPress={e => this.searchFieldKeyPressed(e)}
									onChange={(e, v) => this.setState({ searchText: v })}
								/>
							</div>
							<div className="articles-controls--buttons">
								<ShowHiddenElement onClick={this.changeHiddenShow} />
								<FlatButton
									label="Обновить"
									style={styles.headerButton}
									primary
									icon={<IconRefresh />}
									onClick={this.refreshPage}
									labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
								/>
							</div>
						</header>
						<section className="articles-list">
							<DataGrid items={items} columns={columns}>
								{items.map((edge, i: number) => (
									<MainListItem key={i} article={edge} history={this.props.history} />
								))}
							</DataGrid>
						</section>
					</section>
					<footer className="articles-footer">
						<Pagination totalPage={this.state.totalPages} currentPage={this.state.pageCursor} changePage={this.changePage} />
					</footer>
				</div>
			</section>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		Main,
		graphql`
			fragment Main_viewer on Viewer
				@argumentDefinitions(page: { type: "Int!" }, search: { type: "String" }, states: { type: "[ArticleStateType]" }) {
				articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, states: $states) {
					totalCount
					articles {
						id
						title
						sectionName
						section
						availableAt
						state
						authorName
					}
				}
			}
		`,
		graphql`
			query Main_Refetch_Query($page: Int!, $search: String, $states: [ArticleStateType]) {
				viewer {
					...Main_viewer @arguments(page: $page, search: $search, states: $states)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/main/Main.js